import React from "react";
import locale from "../../locale";

class LayoutFooter extends React.Component
{
	render()
	{
		const {settings} = this.props;

		if (!settings) {
			return null;
		}

		const textParams = settings.textParams || {};
		textParams.currentYear = (new Date()).getFullYear();
		const text = locale.getProperty(settings, 'text', textParams) || locale.get('footer', textParams);

		return (
			<footer>
				{text.split('\n')
					.map((text, index) => <p
						key={`footer_text_line_${index}`}
						dangerouslySetInnerHTML={{__html: text}}
					/>)
				}
			</footer>
		);
	}
}

export default LayoutFooter;
